import React from "react";
import {Create, Edit, SimpleForm, TextInput} from 'react-admin';


const RecordTitle = ({record}) => (
    <span>Record {record ? `"${record.slug || record.name}"` : ''}</span>
);

const CrewForm = (props) => (
    <SimpleForm {...props} >
        <TextInput label="Id" source="id" readonly />
        <TextInput label="slug" source="slug" readonly/>
        <TextInput source="name"  />
        <TextInput label="Created date" source="createdAt" readonly/>
        <TextInput label="Updated date" source="updatedAt" readonly/>
    </SimpleForm>
);

export const CrewEdit = (props) => (
    <Edit title={<RecordTitle />} {...props}>
        <CrewForm />
    </Edit>

);


export const CrewCreate = (props) => (
    <Create title={<RecordTitle />} {...props}>
        <CrewForm/>
    </Create>
);
